export const getAdminPermissions = (state) => {
  return state.auth.adminPermissions;
};
